<template>
  <div class="pointer-events-none fixed inset-0 flex items-start justify-end p-6 px-4" style="z-index: 5000;">
    <div class="w-full max-w-sm">
      <TransitionGroup name="toasts">
        <div
          v-for="notification in toasts"
          :key="notification.id"
          class="notification pointer-events-auto relative mt-4 rounded-lg bg-white p-4 shadow-[0_0_8px_0_rgba(15,23,42,0.16)]"
          @click="removeToast(notification.id)"
        >
          <Btn class="!absolute right-3 top-3" @click="removeToast(notification.id)">
            <XIcon class="size-4" />
          </Btn>
          <div class="flex">
            <div class="ml-3">
              <div v-if="notification.title" cy="notification-title" class="pr-10 text-xs font-bold text-slate-900">
                {{ notification.title }}
              </div>
              <p v-if="notification.text" class="mt-2 text-xs text-slate-900">
                <span class="float-end h-2 w-10" />
                {{ notification.text }}
              </p>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import XIcon from '~/components/Icons/XIcon.vue'
import Btn from '~/components/UI/Btn.vue'
import { useToast } from '~/composables/useToast'

const { toasts, removeToast } = useToast()
</script>

<style scoped>
.toasts-move,
.toasts-enter-active,
.toasts-leave-active {
  transition: all 0.5s ease-out;
}
.toasts-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.toasts-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
/* .toasts-leave-active {
  position: absolute;
} */
</style>
